import { createContext, useContext, useState } from 'react';

const FilterContext = createContext();

export const useFilterContext = () => useContext(FilterContext);

export const FilterProvider = ({ children }) => {
  const [filterCategories, setFilterCategories] = useState([]);
  const [filterTitle, setFilterTitle] = useState('');

  return (
    <FilterContext.Provider value={{
      filterCategories,
      setFilterCategories,
      filterTitle,
      setFilterTitle
    }}>
      {children}
    </FilterContext.Provider>
  );
};